import * as yup from "yup";
import { FileModel } from "../../interfaces/FileModel";
import { GrupoInvMiembroArchivo } from "../../interfaces/Grupos/GruposDTO";

export const UsuarioValidate = yup.object().shape({
  roles: yup.array().of(
    yup.object().shape({
      idrol: yup.number().required("Debe indicar Rol"),
      idunidad: yup.number().required("Debe indicar Unidad"),
      estado: yup.string().required("Debe indicar Estado")
    })
  )
});

export const SolicitudProyValidate = yup.object().shape({
  cabecera: yup.object().shape({
    justificacion: yup.string().trim().required("Debe justificar la solicitud."),
    tipoSolicitud: yup.string().trim().required("Seleccione el tipo."),
    fechaAmpliacion: yup.date().when('tipoSolicitud', {
      is: 'A' || 'F',
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.notRequired(),
      // then: (schema) => schema.required('Fecha de fin es requerida para proyectos a largo plazo'),
      // otherwise: yup.date().notRequired(),
    }),
  })
});

export const EstudianteActivoValidate = yup.object().shape({
  codestudiante: yup.string().trim().required("Ingrese una matricula")
    .matches(/^\d{9}$/, "La matrícula debe tener exactamente 9 dígitos"),
});



// Esquema de validación usando Yup para el formulario Itinerario


export const SolicitudItinerarioValidate = yup.object().shape({
  itinerario: yup.object().shape({
    temainv: yup.string().trim().required('El tema es requerido')
      .test('requiredIfLegth', 'Se excedio el máximo de caracteres 300', function (value) {
        return value !== undefined ? value.length <= 300 : true;
      }),
    codigomateria: yup.string().trim().required('La materia es requerida'),
    mailtutor: yup.string().trim().required('El tutor es requerido'),
    objgeneral: yup.string().trim().required('El objetivo general es requerido')
      .test('requiredIfLegth', 'Se excedio el máximo de caracteres 300', function (value) {
        return value !== undefined ? value.length <= 300 : true;
      }),
  }),
  objespecificos: yup.array().of(
    yup.object().shape({
      objespec: yup.string().required('El objetivo específico es requerido')
        .test('requiredIfLegth', 'Se excedio el máximo de caracteres 300', function (value) {
          return value !== undefined ? value.length <= 300 : true;
        }),
    })
  ).test('min-length', 'Debe agregar al menos un objetivo específico', function (value) {
    return value && value.length > 0;
  }),
  cronograma: yup.array().of(
    yup.object().shape({
      actividad: yup.string().trim().required('La actividad es requerida')
        .test('requiredIfLegth', 'Se excedio el máximo de caracteres 300', function (value) {
          return value !== undefined ? value.length <= 300 : true;
        }),
      fechainicio: yup.date().required('La fecha de inicio es requerida').nullable(),
      fechafin: yup.date().required('La fecha de fin es requerida').nullable(),
      presencial: yup.boolean(),
    })
  ).test('min-length', 'Debe haber varias actividades en la lista', function (value) {
    return value && value.length > 1;
  })
});

export const DatosGrupoValidate = yup.object().shape({
  nombre: yup.string().trim().required('El nombre es obligatorio')
    .test('requiredIfLegth', 'Se excedio el máximo de caracteres 250', function (value) {
      return value !== undefined ? value.length <= 250 : true;
    }),
  objetivogrupo: yup.string().trim().required('El objetivo es obligatorio')
    .test('requiredIfLegth', 'Se excedio el máximo de caracteres 500', function (value) {
      return value !== undefined ? value.length <= 500 : true;
    }),
  grupoObjEspecificos: yup
    .array()
    .of(
      yup.object().shape({
        objetivo: yup
          .string()
          .trim()
          .required('El objetivo específico es obligatorio')
          .max(500, 'Máximo 500 caracteres')
      })
    )
    .min(2, 'Debe ingresar al menos 2 objetivos específicos')
});

export const MiembroGrupoSchema = yup.object().shape({
  numeroidentificacion: yup.string()
    .required("El número de identificación es obligatorio"),

  iddecinvgrupoinvestigacionmiembro: yup.number().nullable().default(0),
  iddecinvgrupoinvestigacion: yup.number().nullable().default(0),
  idpersona: yup.number().nullable().default(0),

  tipo: yup.number()
    .required("Debe seleccionar un tipo")
    .oneOf([1, 2], "Tipo no válido"),

  nombrecompleto: yup.string()
    .required("El nombre completo es obligatorio")
    .min(3, "El nombre debe tener al menos 3 caracteres"),

  clasificacion: yup.string()
    .required("Debe seleccionar una clasificación"),

  estado: yup.string()
    .nullable()
    .default("P"),

  idunidad: yup.number().nullable(),
  idcentro: yup.number().nullable(),

  institucion: yup.string()
    .nullable()
    .when("tipo", {
      is: 2,
      then: (schema) => schema.required("Debe ingresar nombre de la Institución"),
      otherwise: (schema) => schema.notRequired(),
    }),

  email: yup.string()
    .required("El correo electrónico es obligatorio")
    .email("Debe ingresar un correo válido"),

  curriculum: yup
    .mixed<FileModel>()
    .nullable()
    .when("tipo", {
      is: 2,
      then: (schema) =>
        schema.test(
          "cv-required-if-not-exists",
          "Debe adjuntar el CV",
          function (value) {
            const context = this.options.context as
              | { archivos?: GrupoInvMiembroArchivo[] }
              | undefined;

            const existeCV = context?.archivos?.some(
              (x) => x.tipoarchivo === "CV"
            );

            // Ya existe en backend → OK
            if (existeCV) return true;

            // No existe → obligatorio subir
            return value !== null;
          }
        ),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),

  formato: yup
    .mixed<FileModel>()
    .nullable()
    .when("tipo", {
      is: 2,
      then: (schema) =>
        schema.test(
          "ft-required-if-not-exists",
          "Debe adjuntar el Formato",
          function (value) {
            const context = this.options.context as
              | { archivos?: GrupoInvMiembroArchivo[] }
              | undefined;

            const existeFT = context?.archivos?.some(
              (x) => x.tipoarchivo === "FT"
            );

            // Ya existe en backend → OK
            if (existeFT) return true;

            // No existe → obligatorio subir
            return value !== null;
          }
        ),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),
})
  .test(
    "unidad-o-centro",
    "Centro inválido",
    function (values) {
      if (!values || values.tipo !== 1) return true;

      const unidadValida = values.idunidad && values.idunidad !== 0;
      const centroValido = values.idcentro && values.idcentro !== 0;

      if (unidadValida || centroValido) return true;

      return this.createError({
        path: "idunidad", // ❗ el error aparece en idunidad
        message: "Debe seleccionar una Unidad o un Centro",
      });
    }
  );


export const CambioEstadoValidate = yup.object().shape({
  Estado: yup.string().required("El título es obligatorio"),
});

export const ReasignarGrupoValidate = yup.object().shape({
  Iddecinvgrupoinvestigacion: yup.number().required(),
  IdNuevoEncargado: yup.number().moreThan(0, 'Se requiere un nuevo representante').required('Se requiere un nuevo representante')
});

export const FormularioOtriValidate = yup.object().shape({
  title: yup.string().required("El título es obligatorio"),
  abstract: yup.string().required("El abstract es obligatorio"),
  top_k: yup.number().required(),
});

export const FormularioLineasInv = yup.object().shape({
  nombrelineainv: yup
    .string()
    .trim()
    .required('El nombre es obligatorio')
    .max(250, 'Se excedió el máximo de caracteres 250'),

  iddecinvareaconocimiento: yup
    .number()
    .required('El área de conocimiento es obligatorio')
    .moreThan(0, 'Debe seleccionar un área de conocimiento válida'),
});

export const FormularioGrupoLineasInv = yup.object().shape({
  iddecinvareaconocimiento: yup
    .number()
    .required('El área de conocimiento es obligatorio')
    .moreThan(0, 'Debe seleccionar un área de conocimiento válida'),

  iddecinvlineasinvestigacion: yup
    .number()
    .required('La línea de investigación es obligatoria')
    .moreThan(0, 'Debe seleccionar una línea de investigación válida'),
});

export const DeudasPersonaSchemaUpd = yup
  .object()
  .shape({
    idInvObligacion: yup
      .number()
      .required("El ID de la obligación es obligatorio"),

    idpersona: yup
      .number()
      .required("La persona es obligatoria"),

    idInvTipoObligacion: yup
      .number()
      .required("El tipo de obligación es obligatorio"),

    nombrecompleto: yup
      .string()
      .required("El nombre es obligatorio")
      .min(3, "Nombre muy corto"),

    archivos: yup
      .array()
      .required("Debe existir el arreglo de archivos"),

    // =========================
    // CHECKBOXES
    // =========================
    selectDocpago: yup.boolean(),

    selectCertpart: yup.boolean(),

    selectArtcient: yup.boolean(),

    // =========================
    // ARCHIVOS
    // =========================
    docpago: yup.mixed().nullable(),

    certpart: yup.mixed().nullable(),

    artcient: yup.mixed().nullable(),

    // =========================
    // DESCRIPCIONES CONDICIONALES
    // =========================
    docpagoDescp: yup.string().when("selectDocpago", {
      is: true,
      then: (schema) =>
        schema
          .trim()
          .required("Debe ingresar descripción para Documento de Pago"),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),

    certpartDescp: yup.string().when("selectCertpart", {
      is: true,
      then: (schema) =>
        schema
          .trim()
          .required("Debe ingresar descripción para Certificado"),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),

    artcientDescp: yup.string().when("selectArtcient", {
      is: true,
      then: (schema) =>
        schema
          .trim()
          .required("Debe ingresar descripción para Artículo"),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),
  })
  .test(
    "minimo-uno",
    "",
    function (values) {
      const valido =
        values?.selectDocpago ||
        values?.selectCertpart ||
        values?.selectArtcient;

      if (valido) return true;

      return this.createError({
        path: "selectDocpago",
        message: "Debe seleccionar al menos una obligación",
      });
    }
  );

export const DeudasPersonaSchemaPost = yup.object().shape({
  idInvObligacion: yup.number()
    .required("El ID de la obligación es obligatorio"),

  idpersona: yup.number()
    .required("La persona es obligatoria"),

  idInvTipoObligacion: yup.number()
    .required("El tipo de obligación es obligatorio"),

  fechaIngreso: yup.date()
    .typeError("Fecha de ingreso inválida")
    .required("La fecha de ingreso es obligatoria"),

  fechaLimite: yup.date()
    .typeError("Fecha límite inválida")
    .required("La fecha límite es obligatoria")
    .min(
      yup.ref("fechaIngreso"),
      "La fecha límite no puede ser menor a la fecha de ingreso"
    ),

  numeroidentificacion: yup.string()
    .required("La identificación es obligatoria")
    .min(8, "Identificación muy corta"),

  nombrecompleto: yup.string()
    .required("El nombre es obligatorio")
    .min(3, "Nombre muy corto"),

  email: yup.string()
    .email("Correo inválido")
    .required("El email es obligatorio"),

  archivos: yup.array()
    .required("Debe existir el arreglo de archivos"),

  // =========================
  // CHECKBOXES
  // =========================

  selectDocpago: yup.boolean(),

  selectCertpart: yup.boolean(),

  selectArtcient: yup.boolean(),

  // =========================
  // DESCRIPCIONES
  // =========================

  docpagoDescp: yup.string().when("selectDocpago", {
    is: true,
    then: (schema) =>
      schema
        .trim()
        .required("Debe ingresar descripción para Documento de Pago"),
    otherwise: (schema) => schema.notRequired(),
  }),

  certpartDescp: yup.string().when("selectCertpart", {
    is: true,
    then: (schema) =>
      schema
        .trim()
        .required("Debe ingresar descripción para Certificado"),
    otherwise: (schema) => schema.notRequired(),
  }),

  artcientDescp: yup.string().when("selectArtcient", {
    is: true,
    then: (schema) =>
      schema
        .trim()
        .required("Debe ingresar descripción para Artículo"),
    otherwise: (schema) => schema.notRequired(),
  }),
})
.test(
  "minimo-uno",
  "",
  function (values) {

    const valido =
      values?.selectDocpago ||
      values?.selectCertpart ||
      values?.selectArtcient;

    if (valido) return true;

    return this.createError({
      path: "selectDocpago",
      message: "Debe seleccionar al menos una obligación"
    });
  }
);